<template>
  <!--  用户访问数据权限1 客户，2 供应商，3 商品，4 仓库， 5 人员 -->
  <div class="defaultViewStyle">
    <el-tabs v-model="accessAright">
      <el-tab-pane v-for="item in accessList" :key="item.code" :name="item.code" :label="item.name" lazy>
        <employee-access-customer v-if="item.code === 1"/> <!-- 1 用户访问客户 -->
        <employee-access-supplier v-else-if="item.code === 2"/> <!-- 2 用户访问供应商 -->
        <employee-access-product v-else-if="item.code === 3" /> <!-- 3 用户访问商品权限 -->
        <employee-access-warehouse v-else-if="item.code === 4"/> <!-- 4 用户访问仓库 -->
        <div style="width: 300px" v-else>
<!--          {{warehouseSelected}}：：-->
<!--          <warehouse-select v-model="warehouseSelected" :multi="true"/>-->
<!--          {{productSelected}}::-->
<!--          <product-select v-model="productSelected" :multi="true"/>-->
<!--          {{customerSelected}}::-->
<!--          <customer-select v-model="customerSelected" :multi="true"/>-->
<!--          {{supplierSelected}}::-->
<!--          <supplier-select v-model="supplierSelected" :multi="true"/>-->
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import EmployeeAccessProduct from "@/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessProduct.vue";
import EmployeeAccessCustomer from "@/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessCustomer.vue";
import EmployeeAccessSupplier from "@/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessSupplier.vue";
import EmployeeAccessWarehouse from "@/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessWarehouse.vue";

import WarehouseSelect from "@/components/h5/product/WarehouseSelect.vue";
import ProductSelect from "@/components/h5/product/ProductSelect.vue";
import CustomerSelect from "@/components/h5/partner/CustomerSelect.vue";
import SupplierSelect from "@/components/h5/partner/SupplierSelect.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    EmployeeAccessProduct, EmployeeAccessCustomer, EmployeeAccessSupplier, EmployeeAccessWarehouse,
    ProductSelect, CustomerSelect, SupplierSelect, WarehouseSelect
  },
  data() {
    return {
      accessList: [], // 已开启的数据权限范围
      accessAright: 0,
      warehouseSelected: "20260831165908985121,20260901182536049121,20260901182550850121,20260901182600691121",
      productSelected: "20260831103831708111,20260831112605532111,20260831171334808121",
      customerSelected: "20260825104315478111,20260901170349914121,20260902100029968111,20260902100142617111",
      supplierSelected: "20260825105329231111,20260901170416396121,20260902100159494111,20260902100206095111",
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    // 获取数据权限范围
    Util.getSystemSettingOptions("DATA_ACCESS_RANGE").then(res => {
      this.accessList = res;
      if (res.length > 0) {
        this.accessAright = res[0].code;
      }
    })
  },
  methods: {
    queryList() {

    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
</style>